
    /*global server*/
    import { defineComponent } from 'vue';
    import { Form, Field } from "vee-validate";
    import * as yup from "yup";
    import { AxiosError, AxiosResponse } from 'axios';
    import { useProgrammatic } from '@oruga-ui/oruga-next';
    import { useUserStore } from './../../stores/user';

    export default defineComponent({
        components: {
            Form,
            Field
        },
        props: {
            partial: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            const { oruga } = useProgrammatic();

            function successToast() {
                oruga.notification.open({
                    message: 'Successfull Login!',
                    rootClass: 'toast-notification',
                    position: 'top',
                    duration: 5000,
                    variant: 'success'
                });
            }

            function failureToast(errorMessage: string) {
                oruga.notification.open({
                    message: `${errorMessage}`,
                    rootClass: 'toast-notification',
                    position: 'top',
                    variant: 'danger',
                    duration: 10000,
                    closable: true
                });
            }

            const userStore = useUserStore();

            return {
                successToast,
                failureToast,
                userStore,
                form: {
                    UserId: '',
                    Password: ''
                } as server.LoginRequest,
                user: {} as server.User,
                isLoginPageLoading: false as boolean
            }
        },
        computed: {
            schema(): object {
                return yup.object().shape({
                    form: yup.object({
                    })
                });
            }
        },
        methods: {
            onSubmit(): void {
                this.isLoginPageLoading = true;

                this.$axios
                    .post('account/login', this.form)
                    .then((response: AxiosResponse<server.User>) => {
                        if (response.status == 200) {
                            this.userStore.$patch({
                                user: response.data
                            });

                            this.successToast();
                            if (this.partial) {
                                this.$router.push({ name: 'paymentInfo' })
                            } else {
                                this.$router.push(`/`);
                            }

                        }
                    })
                    .catch((error: AxiosError) => {
                        let objectArray = (error.response?.data as any).Error.Errors;

                        Object.keys(objectArray).forEach((key) => {
                            this.failureToast(objectArray[key].ErrorMessage);
                        });
                    })
                    .finally(() => {
                        this.isLoginPageLoading = false;
                    });
            },
            clearfields(): void {
                (this.$refs.formValidator as any).resetForm();
            },
        }
    });
